import { useEffect } from "react";
import AppHeader from "../components/AppHeader";
import BottomNavigation from "../components/BottomNavigation";
import { t, tNode } from "../services/i18n";
import { track } from "../services/analytics";

/**
 * Safety content. ALL items are placeholders by design: the developer must
 * not author medical warnings (spec section 4). Approved intended-use,
 * contraindication, cleaning and storage text plus the official IFU link
 * are inserted at handover, replacing locale keys under "safety".
 */
export default function SafetyPage() {
  const items = tNode<string[]>("safety.items", []);
  useEffect(() => { track("safety_viewed"); }, []);

  return (
    <>
      <AppHeader title={t("safety.title")} backTo="/help" />
      <div className="page page--with-nav">
        <h2 className="h1">{t("safety.heading")}</h2>
        <p className="sub">{t("safety.intro")}</p>
        <ul className="step-list mt-24">
          {items.map((item, i) => (
            <li className="step-item" key={i}>{item}</li>
          ))}
        </ul>
        <div className="info-banner mt-16">
          <strong>{t("safety.disclaimerTitle")}</strong>
          {t("safety.disclaimer")}
        </div>
      </div>
      <BottomNavigation />
    </>
  );
}
